module.exports = __webpack_public_path__ + "img/14.517d2e90.jpg";